import { Outlet } from 'react-router-dom'

import { InstallPrompt } from '@/components/pwa/InstallPrompt'

/**
 * Layout raiz do router: renderiza a rota atual e o card de instalação do PWA,
 * que fica fora dos guards para valer tanto no login quanto na área autenticada.
 */
export function RootLayout() {
  return (
    <>
      <Outlet />
      <InstallPrompt />
    </>
  )
}
